import React, { useState } from 'react';
import { IconButton } from '../../../components/HtmlComponents';
import { removeSpace } from "../../../helpers";
import Notifications from '../../../components/global/Notifications';
import { abnLookup as abnLookupApi } from '../../../api/utilityApi';

/**
 * Reusable ABN Lookup component that works independently of Formik
 * 
 * @param {Object} props
 * @param {string} props.value - The current ABN value
 * @param {function} props.onChange - Function to handle input change
 * @param {function} props.onLookupSuccess - Callback function that receives the lookup data
 * @param {string} props.applicationId - The application ID needed for the API call
 * @param {string} props.token - Authentication token
 * @param {Object} props.className - Optional CSS class for the input field
 * @param {Object} props.style - Optional inline styles for the input field
 * @param {string} props.label - Optional label text (defaults to "ABN")
 */
const ABN_Lookup = ({ 
  value, 
  onChange, 
  onLookupSuccess, 
  entityType = 'application',
  entityId, 
  token, 
  className = "form-control", 
  style = { height: "35px", fontWeight: "400" },
  label = "ABN"
}) => {
  const [abn, setAbn] = useState(value || '');

  const handleChange = (e) => {
    const newValue = e.target.value;
    setAbn(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleLookup = async () => {
    // GENERATE ABN REPORT AND GET THE JSON DATA
    if (removeSpace(abn).length !== 11) {
      Notifications("error", "Please provide ABN (11 characters)");
      return;
    }
    
    try {
      const response = await abnLookupApi(token, entityType, entityId, abn);
      if (response["error"] !== undefined && response["error"] === 0) {
        const payload = response["payload"] !== undefined ? response["payload"] : {};
        if (onLookupSuccess) {
          onLookupSuccess(payload);
        }
      } else {
        Notifications("error", response.message || "Error performing ABN lookup");
      }
    } catch (error) {
      Notifications("error", "Error performing ABN lookup");
      console.error("ABN Lookup Error:", error);
    }
  };

  return (
    <div className="fv-row fv-plugins-icon-container">
      <label className="fs-8 fw-bold mb-2">
        {label} 
        <IconButton 
          buttonOnClick={handleLookup} 
          iconType="search" 
          buttonStyle={{ border: "0px", backgroundColor: "transparent", color: "orange" }} 
          iconColor="orange" 
        />
      </label>
      <input
        type="text"
        className={className}
        style={style}
        value={abn}
        onChange={handleChange}
      />
    </div>
  );
};

export default ABN_Lookup;
